import React from 'react';
import { StarIcon } from 'lucide-react';
import { MINI_TESTIMONIALS } from '../../data/content';
const STATS = [{
  value: '+500',
  label: 'docentes confían',
  color: 'text-lime'
}, {
  value: '6',
  label: 'Tomos Completos',
  color: 'text-magenta'
}, {
  value: '5',
  label: 'Bonos Gratis',
  color: 'text-lime'
}, {
  value: '4.9/5',
  label: 'calificación',
  color: 'text-magenta'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-200" data-mp="1lgsvdrvt555j">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-lime text-lime" aria-hidden="true" data-id="element-201" data-mp="1qfdtnlri1erc" data-mpi={i} />)}
    </div>;
}
export function SocialStats() {
  return <section className="relative w-full border-y border-ink-border bg-ink-soft px-5 py-8 sm:py-10" data-id="element-202" data-mp="1z9s85m47gl9e">
      <div className="mx-auto max-w-5xl" data-id="element-203" data-mp="248vd76k6qrhd">
        <div className="grid grid-cols-2 gap-x-4 gap-y-5 sm:grid-cols-4" data-id="element-204" data-mp="249wnh8tdn9y1">
          {STATS.map(s => <div key={s.label} className="text-center" data-id="element-205" data-mp="297pug42i87zd">
              <div className={`font-display text-3xl sm:text-4xl ${s.color}`} data-id="element-206" data-mp="3b8nby0nwqov5">{s.value}</div>
              <div className="mt-0.5 text-xs font-medium text-white/60" data-id="element-207" data-mp="368sjhsohhr7z">{s.label}</div>
            </div>)}
        </div>

        <div className="mt-7 grid gap-3 sm:grid-cols-3" data-id="element-208" data-mp="3288puz34d5ql">
          {MINI_TESTIMONIALS.map(t => <div key={t.name} className="rounded-xl border border-ink-border bg-ink-card p-4" data-id="element-209" data-mp="2xa6upfsf5fyr">
              <Stars data-id="element-210" data-mp="3tyd6cmnrd8mj" />
              <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-211" data-mp="3u0zbkfn6fc1l">“{t.quote}”</p>
              <p className="mt-2 text-xs font-semibold text-white/50" data-id="element-212" data-mp="3pxt79djmjuxr">{t.name} · {t.city}</p>
            </div>)}
        </div>
      </div>
    </section>;
}